import styled, { css } from "styled-components";
import type { UscColorType } from "../../../../../shared-components/lexus/styles/Variables.types";

// STYLES
const separatorStyle = css`
    --_border-color: var(--separator-color, var(--color-platinum-medium));

    display: block;
    width: 100%;
    height: 1px;
    margin-block: 0;
    background: var(--_border-color);
    border: 0;
`;

// COMPONENTS
const Separator = styled.hr<{ color?: UscColorType }>`
    --separator-color: ${({ color }) => (color ? `var(--color-${color})` : "var(--color-platinum-medium)")};
    ${separatorStyle};
`;

export default Separator;
